import { defineComponent as _defineComponent } from 'vue'
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

interface Props {
    slides: Array<{ title: string; image: string; link: string; description: string }>;
    translations: { read_more: string };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'carousel',
  props: {
    slides: { type: Array, required: true },
    translations: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const breakpoints = {
    1: {
        itemsToShow: 1.25,
    },
    768: {
        itemsToShow: 2.1,
    },
    1024: {
        itemsToShow: 2.5,
    },
};

const __returned__ = { props, breakpoints, get Carousel() { return Carousel }, get Slide() { return Slide }, get Navigation() { return Navigation } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})